import styled from "styled-components"

export default styled.div`
  display: flex-item;
  height: 1px;
  min-width: 100%;
  margin-bottom: 15px;
`
